import React from "react";

const DistributeIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19.239"
      height="27.161"
      viewBox="0 0 19.239 27.161"
    >
      <g id="db46" transform="translate(-221.175 -157.426)">
        <path
          id="Path_1289"
          data-name="Path 1289"
          d="M467.07,533.589l3.622-3.678H467.07Z"
          transform="translate(-230.617 -349.341)"
          fill={fill ? fill : "#000"}
        />
        <path
          id="Path_1290"
          data-name="Path 1290"
          d="M340.933,161.614a1.58,1.58,0,0,0-.17-1.584c0-.113-.057-.226-.057-.34v-.566a.535.535,0,0,1,.566-.566H342.4a.535.535,0,0,1,.566.566v.566a.8.8,0,0,1-.113.34,1.492,1.492,0,0,0-.17,1.528l.113.4h1.188l-.226-.792a.78.78,0,0,1,0-.509,1.534,1.534,0,0,0,.34-.962v-.566a1.667,1.667,0,0,0-1.7-1.7h-1.132a1.667,1.667,0,0,0-1.7,1.7v.566a1.907,1.907,0,0,0,.283.962.505.505,0,0,1,0,.566l-.17.736h1.188Z"
          transform="translate(-111.044)"
          fill={fill ? fill : "#000"}
        />
        <path
          id="Path_1291"
          data-name="Path 1291"
          d="M238.717,266.7h-.566v2.377a1.648,1.648,0,0,1,1.132,1.584,1.667,1.667,0,0,1-1.7,1.7H224a1.667,1.667,0,0,1-1.7-1.7,1.648,1.648,0,0,1,1.132-1.584V266.7h-.566a1.667,1.667,0,0,0-1.7,1.7v16.41a2.27,2.27,0,0,0,2.264,2.264h11.883v-4.584a.535.535,0,0,1,.566-.566h4.527V268.4a1.667,1.667,0,0,0-1.7-1.7Zm-8.488,15.844H225.7a.566.566,0,1,1,0-1.132h4.527a.566.566,0,1,1,0,1.132Zm5.659-3.4H225.7a.566.566,0,1,1,0-1.132h10.186a.566.566,0,1,1,0,1.132Zm0-3.4H225.7a.566.566,0,1,1,0-1.132h10.186a.566.566,0,1,1,0,1.132Z"
          transform="translate(0 -102.488)"
          fill={fill ? fill : "#000"}
        />
        <path
          id="Path_1292"
          data-name="Path 1292"
          d="M258.168,237.075h13.581a.608.608,0,0,0,.566-.566.567.567,0,0,0-.566-.566h-.566v-3.961a1.667,1.667,0,0,0-1.7-1.7h-2.377l1.811,5.659h-1.188l-1.754-5.659H264l-1.754,5.659H261l1.754-5.659h-2.32a1.667,1.667,0,0,0-1.7,1.7v3.961h-.566a.566.566,0,0,0,0,1.132Z"
          transform="translate(-34.163 -68.332)"
          fill={fill ? fill : "#000"}
        />
      </g>
    </svg>
  );
};

export default DistributeIcon;
